import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../../src/components/layout'
import styled from 'styled-components'
import { Grid } from '@monorepo-amais/commons/components/Blocks/Grid'
import Download from '../../src/images/download.png'
import imgixUrlOptimizerAuto from '@monorepo-amais/commons/utils/imgixUrlOptimizerAuto'

const Container = styled.div`
	width: 100%;
`
const GridContainer = styled.div`
	width: 80%;
	margin: 0 auto;
	margin-bottom: 15px;
	@media (max-width: 998.98px) {
		width: 100%;
	}
	@media (min-width: 992px) and (max-width: 1199.98px) {
		width: 90%;
	}
	@media (min-width: 768px) and (max-width: 991.98px) {
		width: 92%;
	}
`
const Title = styled.h1`
	text-align: left;
	font-size: 40px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: normal;
	color: ${props => props.theme.colors.black_fonts};
	@media (max-width: 998.98px) {
		&:after {
			content: '';
			float: left;
			width: 120px;
			height: 5px;
			position: relative;
			background-color: ${props => props.theme.colors.primary};
			@media (min-width: 768px) and (max-width: 991.98px) {
				display: none;
			}
		}
	}
`
const DivTxt = styled.div`
	@media (max-width: 998.98px) {
		margin: 0 auto;
		width: 92%;
	}
	@media (min-width: 768px) and (max-width: 991.98px) {
		width: 100%;
	}
`

const GridCustom = styled(Grid)`
	grid-template-columns: repeat(5, 225px);
	grid-template-areas:
		'destaque destaque . . .'
		'destaque destaque . . .'
		'. . . . .'
		'. . . . .'
		'. . . . .';
	grid-gap: 5px 0;

	@media (max-width: 998.98px) {
		grid-template-areas:
			'destaque destaque'
			'destaque destaque'
			'. .'
			'. .'
			'. .';
		grid-gap: 20px;
		justify-content: center;
	}
	@media (min-width: 992px) and (max-width: 1199.98px) {
		width: 100%;
		grid-template-columns: repeat(4, 230px);
		grid-template-areas:
			'destaque destaque . .'
			'destaque destaque . .'
			'. . . .'
			'. . . .'
			'. . . .';
	}

	@media (min-width: 768px) and (max-width: 991.98px) {
		grid-template-columns: repeat(4, 165px);
		grid-template-areas:
			'destaque destaque . .'
			'destaque destaque . .'
			'. . . .'
			'. . . .'
			'. . . .';
		grid-gap: 15px;
		width: 100%;
	}
	.destaque {
		grid-area: destaque;
	}
`
const ImgDestaque = styled.img`
	width: 424px;
	height: 557px;
	@media (max-width: 998.98px) {
		width: 345px;
		height: 453px;
	}
`

// const DivImgMask = styled.div`
// 	display: none;
// `

const DownloadPDF = styled.a`
	display: none;
	z-index: 1;
	position: absolute;
	top: 45%;
	/* left: 50%; */
	transform: translate(-50%, -50%);
`

const DivHoverDestaque = styled.div`
	position: relative;
	width: 424px;
	height: 557px;
	@media (max-width: 998.98px) {
		width: 345px;
		height: 453px;
	}
	&:hover {
		${DownloadPDF} {
			left: 50%;
			top: 50%;
			position: absolute;
			display: block;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.5);
			transition: 0.3s ease-in-out;
		}
	}
`
const DivImg = styled.div`
	position: relative;
	width: 200px;
	height: 276px;
	@media (max-width: 998.98px) {
		width: 160px;
		height: 224px;
	}
	&:hover {
		${DownloadPDF} {
			left: 50%;
			top: 50%;
			position: absolute;
			display: block;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.5);
			transition: 0.3s ease-in-out;
		}
	}
`
const Icon = styled.img`
	display: block;
	margin-top: 55%;
	margin-left: 40%;
`

const IconB = styled.img`
	display: block;
	margin-top: 55%;
	margin-left: 30%;
`

const ImgRevistas = styled.img`
	width: 200px;
	height: 276px;
	margin-bottom: 5px;
	@media (max-width: 998.98px) {
		max-width: 160px;
		height: 224px;
	}
	@media (min-width: 992px) and (max-width: 1199.98px) {
		width: 100%;
	}
	@media (min-width: 768px) and (max-width: 991.98px) {
		width: 100%;
	}
`
const TextP = styled.p`
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.31;
	letter-spacing: normal;
	text-align: left;
	color: ${props => props.theme.colors.gray66};
	@media (max-width: 998.98px) {
		font-size: 18px;
	}
`
const TitleP = styled.p`
	font-size: 22px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: 0.75;
	letter-spacing: normal;
	text-align: left;
	color: ${props => props.theme.colors.black_fonts};
`
const DescP = styled.p`
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 0;
	letter-spacing: normal;
	text-align: left;
	color: ${props => props.theme.colors.gray66};
`
const Underline = styled.div`
	height: 5px;
	width: 90px;
	margin-top: -28px;
	background-color: ${props => props.theme.colors.primary};
	@media (max-width: 998.98px) {
		display: none;
	}
	@media (min-width: 768px) and (max-width: 991.98px) {
		display: block;
	}
`

const PageRevistas = ({ data }) => {
	const informacoes = data.allCosmicjsInformacoesEstaticas.edges
	const enumMes = {
		janeiro: 1,
		fevereiro: 2,
		março: 3,
		abril: 4,
		maio: 5,
		junho: 6,
		julho: 7,
		agosto: 8,
		setembro: 9,
		outubro: 10,
		novembro: 11,
		dezembro: 12
	}
	const revistas = data.allCosmicjsRevistas.nodes.sort((prev, next) => {
		const prevDate = prev.metadata.data.split(' ')
		const nextDate = next.metadata.data.split(' ')
		const prevYear = prevDate[2]
		const nextYear = nextDate[2]
		const prevMonth = prevDate[0]
		const nextMonth = nextDate[0]
		const d1 = new Date(`${prevYear}-${enumMes[prevMonth.toLowerCase()]}`)
		const d2 = new Date(`${nextYear}-${enumMes[nextMonth.toLowerCase()]}`)
		return d1 > d2 ? -1 : 1
	})
	return (
		<>
			<Layout>
				<Container>
					<GridContainer>
						{informacoes.map((itens, index) => (
							<DivTxt key={itens.node.metadata.title}>
								<Title id={`title-magazine-details-${index}`}>{itens.node.metadata.title}</Title>
								<Underline />
								<TextP>{itens.node.metadata.conteudo}</TextP>
							</DivTxt>
						))}
						<GridCustom>
							<div className='destaque'>
								<DivHoverDestaque>
									<DownloadPDF href={revistas[0].metadata.pdf.url} target='_blank' download='proposed_file_name'>
										<Icon src={Download} />
									</DownloadPDF>
									<ImgDestaque src={imgixUrlOptimizerAuto(revistas[0].metadata.capa.imgix_url)} />
								</DivHoverDestaque>
								<TitleP id='title-featured-magazine-edition'>{revistas[0].metadata.edicao}</TitleP>
								<DescP>{revistas[0].metadata.data}</DescP>
							</div>
							{revistas.slice(1).map(item => (
								<div key={item.metadata.edicao}>
									<DivImg>
										<DownloadPDF href={item.metadata.pdf.url} target='_blank' download='proposed_file_name'>
											<IconB src={Download} />
										</DownloadPDF>
										<ImgRevistas src={imgixUrlOptimizerAuto(item.metadata.capa.imgix_url)} />
									</DivImg>
									<TitleP id={`title-magazine-edition-${item.metadata.edicao}`}>{item.metadata.edicao}</TitleP>
									<DescP>{item.metadata.data}</DescP>
								</div>
							))}
						</GridCustom>
					</GridContainer>
				</Container>
			</Layout>
		</>
	)
}

export default PageRevistas
export const query = graphql`
	query {
		allCosmicjsInformacoesEstaticas(filter: { title: { eq: "Revistas" } }) {
			edges {
				node {
					slug
					metadata {
						conteudo
						title
					}
				}
			}
		}

		allCosmicjsRevistas {
			nodes {
				title
				slug
				metadata {
					pdf {
						url
						imgix_url
					}
					edicao
					capa {
						imgix_url
						url
					}
					data
				}
			}
		}
	}
`
